import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAddBanner } from "../../../api/banner/use-banner";
import { uploadImage } from "../../../api/helper/upload-image";
import { useAddEvent } from "../../../api/inquiries/event/use-event";
import TitlePage from "../../../components/section/TitlePage/Titlepage";
import Button from "../../../components/ui/Button/Button";
import InputDate from "../../../components/ui/InputDate/InputDate";
import Modal from "../../../components/ui/Modal/Modal";
import FieldBox from "../../../utils/Form/ui/FieldBox";
import BannerProductLinkage from "../Section/BannerProductLinkage";

const BannerRegisterPage = () => {
  const navigate = useNavigate();
  const [title, setTitle] = React.useState("");
  const [onAt, setOnAt] = React.useState(null);
  const [bannerImage, setBannerImage] = React.useState("");
  const [bannerAppImage, setBannerAppImage] = React.useState("");
  const [bannerLink, setBannerLink] = React.useState("");
  const [withBannerLink, setWithBannerLink] = React.useState(false);
  const [offAt, setOffAt] = React.useState(null);
  const [selectedDateOption, setSelectedDateOption] = React.useState();
  const [urlMode, setUrlMode] = React.useState("manual");
  const [triggerClose, setTriggerClose] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState({});
  const [product, setProduct] = React.useState({});
  const { mutate: addBanner } = useAddBanner();
  useEffect(() => {
    if (triggerClose === true) {
      setTriggerClose(false);
    }
  }, [triggerClose]);

  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };

  const handleSubmit = async () => {
    const payload = {
      title: title,
      imagePC: bannerImage,
      imageMobile: bannerAppImage,
      onAt: onAt.startOf("day").toDate(),
      offAt: offAt.endOf("day").toDate(),
      location: "ONEDAY Mall 웹/앱 상단",
    };
    const conditionalPayload =
      urlMode === "manual"
        ? { ...payload, url: bannerLink }
        : { ...payload, productGroupId: product?.id };

    await addBanner({ ...conditionalPayload });
  };

  const onClickBannerLink = () => {
    setWithBannerLink(!withBannerLink);
    setBannerLink("");
  };

  const handleBack = () => {
    navigate("/banner-management");
  };
  const onChangeonAt = (value) => {
    setOnAt(value);
  };
  const onChangeBannerLink = (e) => {
    setBannerLink(e.target.value);
  };

  const onChangeoffAt = (value) => {
    setOffAt(value);
  };
  const handlebannerImageUpload = async (event) => {
    const file = event.target.files[0];

    const bannerImageData = new FormData();
    bannerImageData.append("file", file);

    const { data: image } = await uploadImage(bannerImageData);

    setBannerImage(image?.publicUrl);
  };

  const onChangeUrlMode = (e) => {
    setUrlMode(e.target.value);
    setBannerLink("");
    setProduct({});
  };

  const handlebannerAppImageUpload = async (event) => {
    const file = event.target.files[0];

    const bannerImageAppData = new FormData();
    bannerImageAppData.append("file", file);

    const { data: image } = await uploadImage(bannerImageAppData);

    setBannerAppImage(image?.publicUrl);
  };

  const onChangeDateTo = (increment) => {
    if (onAt !== null) {
      setSelectedDateOption(increment);
      if (increment === 1 || increment === 7) {
        const added = onAt.add(increment, "day");
        setOffAt(added);
      }
      if (increment === 30) {
        const added = onAt.add(1, "month");
        setOffAt(added);
      }
      if (increment === 90) {
        const added = onAt.add(3, "month");
        setOffAt(added);
      }
    }
  };

  const handleSelectProduct = (id, name) => {
    setSelectedProduct({
      id: id,
      name: name,
    });
  };

  const onSubmitProduct = () => {
    setProduct(selectedProduct);
    setTriggerClose(true);
  };

  const isEmpty =
    title === "" ||
    onAt === null ||
    offAt === null ||
    bannerImage === "" ||
    bannerAppImage === "" ||
    (Object.keys(product).length === 0 && bannerLink === "");

  return (
    <>
      <div>
        <TitlePage title="배너 관리 > 배너 등록" />
        <div className="mt-4">
          <form>
            <div className="flex items-center">
              <div className="w-1/2">
                <FieldBox
                  splitted
                  splittedWidth="w-48 flex-none"
                  label="사용 시작일"
                >
                  <InputDate
                    value={onAt}
                    onChange={onChangeonAt}
                    defaultValue={onAt}
                  />
                </FieldBox>
              </div>
              <div className="w-1/2">
                <FieldBox
                  splitted
                  splittedWidth="w-48 flex-none"
                  label="사용 종료일"
                >
                  <div className="flex items-center gap-4">
                    <InputDate
                      value={offAt}
                      onChange={onChangeoffAt}
                      defaultValue={offAt}
                    />
                    <div
                      className={`border h-8 text-center rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
                    >
                      <div
                        onClick={() => onChangeDateTo(1)}
                        className={`${
                          selectedDateOption === 1
                            ? "bg-primary-blue rounded-l-[4px] text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px]`}
                      >
                        오늘
                      </div>
                      <div
                        onClick={() => onChangeDateTo(7)}
                        className={`${
                          selectedDateOption === 7
                            ? "bg-primary-blue text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                      >
                        7일
                      </div>
                      <div
                        onClick={() => onChangeDateTo(30)}
                        className={`${
                          selectedDateOption === 30
                            ? "bg-primary-blue text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                      >
                        1개월
                      </div>
                      <div
                        onClick={() => onChangeDateTo(90)}
                        className={`${
                          selectedDateOption === 90
                            ? "bg-primary-blue rounded-r-[4px] text-white"
                            : ""
                        } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                      >
                        3개월
                      </div>
                    </div>
                  </div>
                </FieldBox>
              </div>
            </div>
            <FieldBox unSplittedWidth="w-48 flex-none" label="배너 제목">
              <input
                className="rounded-[4px] w-full text-[12px] px-2 py-1 focus:outline-none"
                placeholder="제목을 입력해주세요"
                name="title"
                value={title}
                onChange={onChangeTitle}
              />
            </FieldBox>
            <FieldBox unSplittedWidth="w-48 flex-none" label="배너 위치">
              <input
                className="rounded-[4px] w-full text-[12px] px-2 py-1 focus:outline-none"
                placeholder="ONEDAY Mall 웹/앱 상단"
                name="location"
                value="ONEDAY Mall 웹/앱 상단"
                readOnly
              />
            </FieldBox>
            <FieldBox unSplittedWidth="w-48 flex-none" label="배너 이미지">
              <div className="flex items-center gap-3 px-2 py-1 ">
                <label htmlFor="bannerImage" className="cursor-pointer">
                  <div className="border border-black w-24 p-[6px] rounded-[4px] flex justify-center">
                    웹 배너 업로드
                    <input
                      id="bannerImage"
                      type="file"
                      className="hidden"
                      accept="image/*"
                      onChange={handlebannerImageUpload}
                    />
                  </div>
                </label>

                <label htmlFor="bannerAppImage" className="cursor-pointer">
                  <div className="border border-black w-24 p-[6px] rounded-[4px] flex justify-center">
                    앱 배너 업로드
                    <input
                      id="bannerAppImage"
                      type="file"
                      className="hidden"
                      accept="image/*"
                      onChange={handlebannerAppImageUpload}
                    />
                  </div>
                </label>
              </div>
              <div className="flex flex-wrap items-center px-2 py-1  gap-4">
                {bannerImage === "" ? (
                  <div className="bg-[#e7e6e6] flex w-[470px] h-[150px]  p-6 text-center">
                    <div className="m-auto">
                      <span className="font-bold"> 웹 배너 미리보기</span>
                      <br />
                      ※ ‘이미지 업로드’ 버튼을 눌러, 배너 이미지를 추가/수정
                      가능합니다
                      <br />
                      <span className="text-[#e80000]">
                        ※ 웹 배너 권장 사이즈 : 959x265.5~1918x531(권장) 배율로
                        업로드 해주세요.
                        <br />
                        (컨텐츠 영역 1918x531 / 전체 영역 1920x531)
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="relative w-[470px] h-[150px] border border-[#cccccc]">
                    <img
                      src={bannerImage}
                      className="object-cover w-full h-full"
                      alt="event"
                    />
                  </div>
                )}
                {bannerAppImage === "" ? (
                  <div className="bg-[#e7e6e6] flex  w-[250px] h-[150px]  p-6 text-center">
                    <div className="m-auto">
                      <span className="font-bold"> 앱 배너 미리보기</span>
                      <br />
                      ※ ‘이미지 업로드’ 버튼을 눌러, 배너
                      <br />
                      이미지를 추가/수정 가능합니다.
                      <br />
                      <span className="text-[#e80000]">
                        ※ 앱 배너 권장 사이즈 :
                        <br />
                        720x430~1440x860 (권장) 배율로
                        <br />
                        업로드 해주세요.
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="relative  w-[220px] h-[150px] border border-[#cccccc]">
                    <img
                      src={bannerAppImage}
                      className="object-cover w-full h-full"
                      alt="event"
                    />
                  </div>
                )}
              </div>
            </FieldBox>
            <FieldBox unSplittedWidth="w-48 flex-none" label="링크 연동 여부">
              <div className="px-2 flex gap-4 h-6">
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="linkStatus"
                    id="selection"
                    className="mr-2 accent-black"
                    value="selection"
                    onChange={onChangeUrlMode}
                  />
                  <label htmlFor="selection">내부 링크</label>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="linkStatus"
                    id="manual"
                    value="manual"
                    className="mr-2 accent-black"
                    onChange={onChangeUrlMode}
                    defaultChecked={true}
                  />
                  <label htmlFor="manual">연결 외부 URL</label>
                </div>
              </div>
            </FieldBox>
            <FieldBox
              unSplittedWidth="w-48 flex-none"
              label="연결 외부 URL"
              isLast
            >
              <div className="px-2 flex gap-4 items-center w-[92%]">
                {urlMode === "manual" ? (
                  <input
                    type="text"
                    className={`flex-auto border border-[#cccccc] h-9 w-full py-0.5 px-2 outline-none rounded-[4px]`}
                    value={bannerLink}
                    onChange={onChangeBannerLink}
                    placeholder="외부 연결 링크를 등록해주세요"
                  />
                ) : (
                  <>
                    <Modal
                      hasClose={false}
                      padding="py-4"
                      paddingTitle={`px-6`}
                      maxWidth="max-w-[52rem]"
                      title="상품정보 연동"
                      rightTittle={
                        <div className="flex items-center gap-1">
                          <Button
                            onClick={() => setTriggerClose(true)}
                            width="w-24"
                            text="취소"
                          />
                          <Button
                            onClick={onSubmitProduct}
                            width="w-24"
                            text="연동하기"
                            primary
                          />
                        </div>
                      }
                      description={
                        <BannerProductLinkage
                          handleSelectProduct={handleSelectProduct}
                        />
                      }
                      hasCancel={false}
                      hasSubmit={false}
                      triggerClose={triggerClose}
                    >
                      <button
                        type="button"
                        onClick={onClickBannerLink}
                        className={`flex-none bg-gradient-to-b from-white via-primary-white to-background-grey border border-button-grey w-24 p-[6px] rounded-[4px] flex justify-center`}
                      >
                        상품정보 연동
                      </button>
                    </Modal>
                    <input
                      type="text"
                      className={`flex-auto border border-[#cccccc] h-9 w-full py-0.5 px-2 outline-none rounded-[4px] bg-[#ededed] text-[#999999]`}
                      value={
                        Object.keys(product).length === 0
                          ? ""
                          : `${product?.name}`
                      }
                      disabled={true}
                      placeholder="연동안됨"
                    />
                  </>
                )}
              </div>
            </FieldBox>
            <div className="flex justify-end mt-4">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleBack}
              >
                <Button width="w-24" text="입력취소" />
              </Modal>
              <Modal
                description={
                  <span>
                    입력한 정보로 배너를 등록하시겠습니까? <br />
                    '등록완료'할 경우, 등록된 정보에 따라 병원웹, 병원앱의
                    ONEDAY Mall
                    <br />
                    상단 배너에 리사이징되어 적용됩니다.
                  </span>
                }
                onSubmit={handleSubmit}
                submitText="배너 등록"
                maxWidth="max-w-[26rem]"
                padding="p-5"
                widthSubmitButton="w-24"
              >
                <Button
                  isDisabled={isEmpty}
                  onClick={(e) => e.preventDefault()}
                  type="submit"
                  primary
                  text="등록완료"
                  width="w-24"
                />
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default BannerRegisterPage;
